import { createAction } from 'redux-actions';
export const setCommunicationCategory = createAction('SET_COMMUNICATIONS_CATEGORY');
export const markAllAsReadInCategory = createAction('MARK_ALL_AD_READ_IN_CATEGORY');
export const decreaseUnreadCountByCategory = createAction('DECREASE_UNREAD_COUNT_BY_CATEGORY');
export const increaseUnreadCountByCategory = createAction('INCREASE_UNREAD_COUNT_BY_CATEGORY');
